import React from 'react';
import { Card, Table, Typography } from 'antd';
import { DollarOutlined } from '@ant-design/icons';

const { Text } = Typography;

const CostBreakdownTable = ({ data, title = "Cost Breakdown" }) => {
  // Handle case when data is not available
  if (!data || !Array.isArray(data) || data.length === 0) {
    return (
      <Card title={title} className="dashboard-card">
        <div className="card-content">
          <p>No cost data available</p>
        </div>
      </Card>
    );
  }

  // Calculate total cost
  const totalCost = data.reduce((sum, item) => sum + (item.value || 0), 0);

  // Define table columns
  const columns = [
    {
      title: 'Cost Category',
      dataIndex: 'name',
      key: 'name',
      render: (text, record) => (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div 
            style={{ 
              width: 12, 
              height: 12, 
              backgroundColor: record.color, 
              marginRight: 8,
              borderRadius: '50%'
            }} 
          />
          <Text>{text}</Text>
        </div>
      )
    },
    {
      title: 'Amount',
      dataIndex: 'value',
      key: 'value',
      align: 'right',
      render: (value) => `$${value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
    },
    {
      title: 'Percentage',
      dataIndex: 'percentage',
      key: 'percentage',
      align: 'right',
      render: (percentage) => `${percentage}%`
    }
  ];

  // Add a total row to the data
  const tableData = [
    ...data,
    {
      key: 'total',
      name: 'Total',
      value: totalCost,
      percentage: 100,
      color: '#000000'
    }
  ];

  return (
    <Card 
      title={
        <div className="card-title">
          <DollarOutlined /> {title}
        </div>
      } 
      className="dashboard-card"
    >
      <div className="card-content">
        <Table 
          dataSource={tableData} 
          columns={columns} 
          pagination={false}
          size="small"
          rowKey="name"
          rowClassName={(record) => record.key === 'total' ? 'total-row' : ''}
        />
      </div>
      <style>{`
        .total-row {
          font-weight: bold;
          background-color: #f0f2f5;
        }
      `}</style>
    </Card>
  );
};

export default CostBreakdownTable;
